// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AdditionalInfo_codeSection__3NSc1{margin-bottom:1.5rem !important;margin-top:1.5rem !important}", "",{"version":3,"sources":["webpack://./src/bepaid/components/AddCustomerForm/CustomerAdditionalInfo/AdditionalInfo.module.scss"],"names":[],"mappings":"AAAA,mCAAa,+BAA+B,CAAC,4BAA4B","sourcesContent":[".codeSection{margin-bottom:1.5rem !important;margin-top:1.5rem !important}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"codeSection": "AdditionalInfo_codeSection__3NSc1"
};
export default ___CSS_LOADER_EXPORT___;
